import { useEffect } from "react";

export default function AdminLayout({ children }) {
  useEffect(() => {
    const container = document.querySelector(".app-shell-private");
    if (container) {
      container.scrollTo({ top: 0, behavior: "auto" });
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, []);

  return children;
}
